<template lang="html">
  <div>
    <vs-row vs-w="12" vs-justify="space-between">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="5" vs-xs="5">
        <div class="vx-col w-full">
          <vs-input class="w-full mt-1" label="Correo electrónico" v-model="mail" name="email" v-validate="'required|email'"/>
          <span class="text-danger text-sm" v-show="errors.has('email')">El campo debe ser un correo electrónico válido</span>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="5" vs-xs="5">
        <div class="vx-col w-full">
          <vs-input class="w-full mt-4" label="Nombre" v-model="name" v-validate="'required|alpha_spaces'" name="name"/>
          <span class="text-danger text-sm" v-show="errors.has('name')">Campo requerido</span>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="5" vs-xs="5">
        <div class="vx-col w-full">
          <vs-input class="w-full mt-4" label="Apellido" v-model="lastname" v-validate="'required|alpha_spaces'" name="lastname"/>
          <span class="text-danger text-sm" v-show="errors.has('lastname')">Campo requerido</span>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="5" vs-xs="5">
        <div class="vx-col w-full">
          <vs-input class="w-full mt-4" label="Teléfono" v-model="phone" v-validate="'required|min:14|max:14'" name="phone" v-on:keypress="isNumber($event)"/>
          <span class="text-danger text-sm" v-show="errors.has('phone')">Campo requerido</span>
        </div>
      </vs-col>
    </vs-row>
    <br>
    <vs-button class="w-full" @click="createSolicitante()" :disabled="!completeInfo">Siguiente</vs-button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  props: {
    caso: {
      type: Object,
      required: false
    },
    variante: {
      type: Number,
      required: false
    },
    casoId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      key:'',
      mail:'',
      name:'',
      lastname:'',
      phone:'',
      ejecutivo:'',
    }
  },
  watch: {
    phone: function(newValue) {
      this.phone= newValue.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3")
    },
  },
  computed:{
    completeInfo(){
      return (this.name != '' && this.lastname != '' && this.phone != '' && this.emailState)
    },
    emailState() {
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const matches = regex.test(this.mail);
      return matches
    },
  },
  mounted(){
    this.getApiKey(this.$route.params)
    this.key=this.$store.state.key
  },
  methods:{
    ...mapMutations(['getApiKey','saveSolicitante','savePhone']),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    createSolicitante(){
      var objRequestRegistraSolicitante = {
        strApiKey: this.key,
        strMetodo: 'RegistraSolicitante',
        objSolicitante: {
          EMail: this.mail,
          Nombres: this.name,
          ApellidoPaterno: this.lastname,
          TelefonoCelular: this.phone,
          FechaNacimiento: "1989-08-16",
        }
      }

      this.$axios.post('/',objRequestRegistraSolicitante,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.saveSolicitante(this.mail)
            this.savePhone(this.phone)
            this.$emit('nextTab',true)
          }
        }
      ).catch(function (error) {
        console.log(error);
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>
